<li>
  <a class="sidebar-item" role="menuitem" tabindex="-1" [routerLink]="url" routerLinkActive="active">{{ label }} </a>
</li>
